let HOST = "https://node.mobilepoolspaapp.com:8000/api/v1/";
export const BASE_URL = "https://node.mobilepoolspaapp.com:8000/api/v1/";
export const BASE_URL_IMAGE = "https://node.mobilepoolspaapp.com:8000/images/";
export const BASE_URL_VIDEO = "https://node.mobilepoolspaapp.com:8000/videos/";

export default HOST;